import { Routes, Route } from "react-router-dom";
import AssignmentLayout from "./AssignmentLayout";

import AssignmentsHome from "./pages/AssignmentsHome";
import CreateEngagement from "./pages/CreateEngagement";
import EngagementRegister from "./pages/EngagementRegister";
import EngagementDetail from "./pages/EngagementDetail";

const AssignmentRoutes = () => {
  return (
    <Routes>
      <Route element={<AssignmentLayout />}>
        <Route index element={<AssignmentsHome />} />
        <Route path="create" element={<CreateEngagement />} />
        <Route path="register" element={<EngagementRegister />} />
        <Route path=":id" element={<EngagementDetail />} />
        <Route path="edit/:id" element={<CreateEngagement isEdit />} />
      </Route>
    </Routes>
  );
};

export default AssignmentRoutes;
